const SOCIALS = [
  { id: "whatsapp", label: "WhatsApp", icon: "fa-whatsapp", href: "https://wa.me/393272653401" },
  { id: "instagram", label: "Instagram", icon: "fa-instagram", href: "https://www.instagram.com/m.j.official95" },
  { id: "facebook", label: "Facebook", icon: "fa-facebook-f", href: "https://www.facebook.com/share/1KMr18G1Jt/" },
  { id: "youtube", label: "YouTube", icon: "fa-youtube", href: "https://youtube.com/@manuanimegames" },
  { id: "tiktok", label: "TikTok", icon: "fa-tiktok", href: "https://www.tiktok.com/@mcanimetcgshop" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0b0b0f] text-white">
    <div className="neon-line" />
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-8 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <div className="font-display text-xl font-extrabold">Contatti</div>
          <p className="mt-1 text-sm text-white/60">Scrivici per info su articoli, disponibilità e spedizioni.</p>
        </div>
        <div className="flex flex-wrap gap-3">
          <a
            href="mailto:info@mcanime.it"
            data-testid="footer-email-link"
            className="inline-flex items-center gap-2 rounded-full border border-[#FFD60A] px-4 py-2 text-sm font-semibold text-[#FFD60A] transition-colors duration-150 hover:bg-[#FFD60A] hover:text-[#0b0b0f]"
          >
            <i className="fa-solid fa-envelope text-base" aria-hidden="true" />
            info@mcanime.it
          </a>
          {SOCIALS.map((s) => (
            <a
              key={s.id}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-${s.id}-link`}
              className="group inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm font-semibold transition-colors duration-150 hover:border-[#FFD60A] hover:bg-[#FFD60A] hover:text-[#0b0b0f]"
            >
              <i className={`fa-brands ${s.icon} text-base`} aria-hidden="true" />
              {s.label}
            </a>
          ))}
        </div>
      </div>
      <div className="mt-10 text-xs text-white/40">© {new Date().getFullYear()} MC Anime - Games - TCG & Shop</div>
    </div>
  </footer>
);
